import { ChangeShared } from "../../../../api/repositories/cdn/models/shared"
import { localize } from "../../../../common/services/localization"
import { getDotaTextWithReplaces } from "../../../../common/utils"
import { HeroTemplateHeaderClass } from "../../layout/blocks"
import { TalentSharedImage } from "../../ui/file-contents"

export const ChangesBlock: React.FC<{
    hero: Hero
    changes: ChangeShared[]
}> = ({ changes, hero }) => {
    const heroName = hero.name

    return <div >
        <div className={`mb-[32px] ${HeroTemplateHeaderClass}`}>
            {localize('hero_changes')}
        </div>
        <div className="flex flex-col gap-[18px] font-['Roboto'] text-[14px] w-[300px] lg:w-full lg:text-18">
            {
                changes.map(change =>
                    <div
                        key={change.name}
                        className="flex items-center justify-start gap-[12px]">
                        <TalentSharedImage
                            className="w-[24px] h-[24px] lg:w-[48px] lg:h-[48px]"
                            heroName={heroName}
                            path={change.name}
                        />
                        <div dangerouslySetInnerHTML={{ __html: getDotaTextWithReplaces(change.description) }} />
                    </div>
                )
            }
        </div>
    </div>
}